

export default function Python() {  
  return (
    <div style={{"height": "calc(100vh - 100px)"}}>
      <iframe title="pythonExec" src="https://trinket.io/embed/python" width="100%" height="100%" frameborder="0" marginWidth="0" marginHeight="0" allowfullscreen></iframe>
    </div>
  );
}
